var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowOk01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "160px",
    height: "159.999px",
    viewBox: "33.507 76.9 160 159.999",
    enableBackground: "new 33.507 76.9 160 159.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1CA94B",
    d: "M113.507,76.9c-44.183,0-80,35.816-80,79.999s35.817,80,80,80c44.182,0,80-35.817,80-80 S157.689,76.9,113.507,76.9z M113.507,216.866c-33.119,0-59.967-26.848-59.967-59.967c0-33.118,26.848-59.966,59.967-59.966 c33.118,0,59.967,26.848,59.967,59.966C173.474,190.018,146.625,216.866,113.507,216.866z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#143A2B",
    d: "M102.293,187.294c-1.779-0.038-3.761-0.825-5.374-2.436 c-7.59-7.572-15.198-15.128-22.734-22.754c-3.324-3.363-3.28-8.494-0.073-11.764c3.252-3.315,8.435-3.41,11.874-0.05 c5.331,5.213,10.589,10.501,15.813,15.82c0.885,0.902,1.303,0.799,2.133-0.035c12.17-12.228,24.387-24.411,36.57-36.628 c2.417-2.424,5.202-3.529,8.579-2.633c6.033,1.602,8.229,8.791,4.166,13.54c-0.318,0.371-0.668,0.717-1.014,1.063 c-14.277,14.279-28.563,28.549-42.823,42.844C107.556,186.119,105.469,187.313,102.293,187.294z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowOk01);
export default __webpack_public_path__ + "static/media/window_ok-01.2180b17a72478760129e426b5587e705.svg";
export { ForwardRef as ReactComponent };